import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

/** Blurred placeholder text for structure-preserving loading states. */
export function ShimmerText({ children, className }: { children?: ReactNode; className?: string }) {
  return (
    <span className={cn('inline-block opacity-50 blur-[3px] select-none', className)} aria-hidden>
      {children ?? '\u00A0'}
    </span>
  );
}
